import { en } from './en';

const i18n = {
    en
};

const DEFAULT_LANGUAGE = 'en';

export const strings = i18n[DEFAULT_LANGUAGE];
